import Nullstack from 'nullstack';
export default function IconTextResize({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-text-resize",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "5",
    cy: "5",
    r: "2"
  }), "   ", Nullstack.element("circle", {
    cx: "19",
    cy: "5",
    r: "2"
  }), "   ", Nullstack.element("circle", {
    cx: "5",
    cy: "19",
    r: "2"
  }), "   ", Nullstack.element("circle", {
    cx: "19",
    cy: "19",
    r: "2"
  }), "   ", Nullstack.element("path", {
    d: "M5 7v10"
  }), "   ", Nullstack.element("path", {
    d: "M7 5h10"
  }), "   ", Nullstack.element("path", {
    d: "M7 19h10"
  }), "   ", Nullstack.element("path", {
    d: "M19 7v10"
  }), "   ", Nullstack.element("path", {
    d: "M10 10h4"
  }), "   ", Nullstack.element("path", {
    d: "M12 14v-4"
  }), " ");
}